<!-- 数据列表（展商首页） -->
<template>
  <div v-loading='pageLoading'>
      <!--展商 基础数据-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('actorBase')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="listForm.actorBase"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('actorBase')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.actorBase == 1}" @click="controlTodo('actorBase', 1, 'actorBase1')">
            <div class="v-repot-data__title">{{$t('look')}}</div>
            <div class="v-repot-data__subTitle">{{$t('lookSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.actorBase['1']}}</span>
              <span class="num2">{{$t('unit2')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.actorBase == 2}" @click="controlTodo('actorBase', 2, 'actorBase2')">
            <div class="v-repot-data__title">{{$t('visit')}}</div>
            <div class="v-repot-data__subTitle">{{$t('visitSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.actorBase['2']}}</span>
              <span class="num2">{{$t('unit')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.actorBase == 3}" @click="controlTodo('actorBase', 3, 'actorBase2')">
            <div class="v-repot-data__title">{{$t('collected')}}</div>
            <div class="v-repot-data__subTitle">{{$t('collectedSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.actorBase['3']}}</span>
              <span class="num2">{{$t('unit4')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['actorBase']">
          <div class="v-report-table__block" v-show="controlList.actorBase == 1">
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="text">{{$t('visitorList')}}</div></div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('actorBase')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.actorBase == 0' @click="exportData('actorBase')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="actorBase1"
                :data="table.actorBase"
                :total="total.actorBase"
                :page="currentPage.actorBase"
                :type="'actorBase'"
                :pageSize="pagination.pageSize"
                @sortChange="sortChange"
                @pageChange="pageChange"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.actorBase == 2 || controlList.actorBase == 3">
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="text">{{$t('visitorList')}}</div></div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('actorBase')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.actorBase == 0' @click="exportData('actorBase')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="actorBase2"
                :data="table.actorBase"
                :total="total.actorBase"
                :page="currentPage.actorBase"
                :type="'actorBase'"
                :pageSize="pagination.pageSize"
                :hideFileds="['times']"
                @sortChange="sortChange"
                @pageChange="pageChange"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
      </div>

      <!--展商 展品统计-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">
            {{$t('prodcutStatistics')}}
          </div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="listForm.product"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('product')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle2')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.product == 1}" @click="controlTodo('product', 1, 'product1')">
            <div class="v-repot-data__title">{{$t('look')}}</div>
            <div class="v-repot-data__subTitle">{{$t('lookSub2')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.product['1']}}</span>
              <span class="num2">{{$t('unit2')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.product == 2}" @click="controlTodo('product', 2, 'product2')">
            <div class="v-repot-data__title">{{$t('lookNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('lookNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.product['2']}}</span>
              <span class="num2">{{$t('unit')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.product == 3}" @click="controlTodo('product', 3, 'product3')">
            <div class="v-repot-data__title">{{$t('collected')}}</div>
            <div class="v-repot-data__subTitle">{{$t('collectedSub2')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.product['3']}}</span>
              <span class="num2">{{$t('unit4')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['product']">
          <div class="v-report-table__block" v-show="controlList.product == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('productListText')}}
                  <span>{{$t('dataListSubTitle')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.product['1']" :placeholder="$t('reportPlaceholder')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn"  @click="searchTable('product', 1)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('product')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.product == 0' @click="exportData('product')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="product1"
                :type="'product'"
                :data="table.product"
                :total="total.product"
                :page="currentPage.product"
                :pageSize="pagination.pageSize"
                :fields="fields.product1"
                :hideFileds="['beCollectionUv', 'beViewUv']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="cell-td" slot-scope="scope">
                    <template v-if="scope.prop == 'productName'">
                      <p v-if="scope.data.row['cnName'] && language == 'zh'">{{scope.data.row['cnName']}}</p>
                      <p v-if="scope.data.row['enName'] && language == 'en'">{{scope.data.row['enName']}}</p>
                    </template>
                    <template v-else>{{scope.data.row[scope.prop]}}</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'product', 1)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.product == 2">
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="text">{{$t('visitorList')}}</div></div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('product')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.product == 0' @click="exportData('product')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="product2"
                :data="table.product"
                :total="total.product"
                :page="currentPage.product"
                :type="'product'"
                :pageSize="pagination.pageSize"
                :fields="fields.product1"
                :hideFileds="['beCollectionUv', 'beViewPv']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                    <template slot="cell-td" slot-scope="scope">
                      <template v-if="scope.prop == 'productName'">
                        <p v-if="scope.data.row['cnName'] && language == 'zh'">{{scope.data.row['cnName']}}</p>
                        <p v-if="scope.data.row['enName'] && language == 'en'">{{scope.data.row['enName']}}</p>
                      </template>
                      <template v-else>{{scope.data.row[scope.prop]}}</template>
                    </template>
                    <template slot="todo-action" slot-scope="scope">
                      <el-button @click="linkVisitorList(scope.data.row, 'product', 2)" type="text" size="small">{{$t('visitorList')}}</el-button>
                    </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.product == 3">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('productListText')}}
                  <span>{{$t('dataListSubTitle5')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.product['3']" :placeholder="$t('reportPlaceholder')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('product', 3)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('product')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.product == 0' @click="exportData('product')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="product3"
                :data="table.product"
                :total="total.product"
                :page="currentPage.product"
                :type="'product'"
                :pageSize="pagination.pageSize"
                :fields="fields.product1"
                :hideFileds="['beViewUv', 'beViewPv']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="cell-td" slot-scope="scope">
                    <template v-if="scope.prop == 'productName'">
                      <p v-if="scope.data.row['cnName'] && language == 'zh'">{{scope.data.row['cnName']}}</p>
                      <p v-if="scope.data.row['enName'] && language == 'en'">{{scope.data.row['enName']}}</p>
                    </template>
                    <template v-else>{{scope.data.row[scope.prop]}}</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'product', 3)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--展商 商脉圈统计-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('opporStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="listForm.opportunity"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('opportunity')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle3')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.opportunity == 1}" @click="controlTodo('opportunity', 1, 'opportunity1')">
            <div class="v-repot-data__title">{{$t('oppNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('oppNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.opportunity['1']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.opportunity == 2}" @click="controlTodo('opportunity', 2, 'opportunity2')">
            <div class="v-repot-data__title">{{$t('comment')}}</div>
            <div class="v-repot-data__subTitle">{{$t('commentSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.opportunity['2']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.opportunity == 3}" @click="controlTodo('opportunity', 3, 'opportunity3')">
            <div class="v-repot-data__title">{{$t('thumbsUp')}}</div>
            <div class="v-repot-data__subTitle">{{$t('thumbsUpSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.opportunity['3']}}</span>
              <span class="num2">{{$t('unit6')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['opportunity']">
          <div class="v-report-table__block" v-show="controlList.opportunity == 1">
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="text">{{$t('oppListText')}}</div></div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('opportunity')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.opportunity == 0' @click="exportData('opportunity')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="opportunity1"
                :type="'opportunity'"
                :data="table.opportunity"
                :total="total.opportunity"
                :page="currentPage.opportunity"
                :pageSize="pagination.pageSize"
                :fields="fields.opportunity1"
                :hideFileds="['action']"
                @sortChange="sortChange"
                @pageChange="pageChange"></VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.opportunity == 2">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('oppListText')}}
                    <span>{{$t('dataListSubTitle2')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.opportunity['2']" :placeholder="$t('reportPlaceholder3')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('opportunity', 2)">{{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('opportunity')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.opportunity == 0' @click="exportData('opportunity')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="opportunity2"
                :type="'opportunity'"
                :data="table.opportunity"
                :total="total.opportunity"
                :page="currentPage.opportunity"
                :pageSize="pagination.pageSize"
                :fields="fields.opportunity1"
                :hideFileds="['likeCount']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'opportunity', 2)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.opportunity == 3">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('oppListText')}}
                    <span>{{$t('dataListSubTitle2')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.opportunity['3']" :placeholder="$t('reportPlaceholder3')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('opportunity', 3)">{{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('opportunity')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.opportunity == 0' @click="exportData('opportunity')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="opportunity3"
                :type="'opportunity'"
                :data="table.opportunity"
                :total="total.opportunity"
                :page="currentPage.opportunity"
                :pageSize="pagination.pageSize"
                :fields="fields.opportunity1"
                :hideFileds="['commentCount']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'opportunity', 3)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--展商 邀约统计-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('inviteStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="listForm.invite"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('invite')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle4')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.invite == 1}" @click="controlTodo('invite', 1, 'invite1')">
            <div class="v-repot-data__title">{{$t('inviteNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('inviteNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.invite['1']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.invite == 2}" @click="controlTodo('invite', 2, 'invite2')">
            <div class="v-repot-data__title">{{$t('sendInviteNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('actorInviteNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.invite['2']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['invite']">
          <div class="v-report-table__block" v-show="controlList.invite == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('inviteListText')}}
                    <span>{{$t('dataListSubTitle3')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.invite['1']" :placeholder="$t('reportPlaceholder4')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('invite', 1)">{{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('invite')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.invite == 0' @click="exportData('invite')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="invite1"
                :type="'invite'"
                :data="table.invite"
                :total="total.invite"
                :page="currentPage.invite"
                :pageSize="pagination.pageSize"
                :fields="fields.invite"
                :hideFileds="['sendTimes']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'invite', 1)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.invite == 2">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('inviteListText')}}
                    <span>{{$t('dataListSubTitle3')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.invite['2']" :placeholder="$t('reportPlaceholder4')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('invite', 2)">{{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('invite')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='total.invite == 0' @click="exportData('invite')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="invite2"
                :type="'invite'"
                :data="table.invite"
                :total="total.invite"
                :page="currentPage.invite"
                :pageSize="pagination.pageSize"
                :fields="fields.invite"
                :hideFileds="['times']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="cell-td" slot-scope="scope">
                    <template v-if="scope.prop == 'sendTimes'">{{scope.data.row['times']}}</template>
                    <template v-else>{{scope.data.row[scope.prop]}}</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'invite', 2)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--展商 IM统计-->
      <!-- <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('IMStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="listForm.IM"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('IM')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle5')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.IM == 1}" @click="controlTodo('IM', 1, 'IM1')">
            <div class="v-repot-data__title">{{$t('IMNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('IMNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.IM['1']}}</span>
              <span class="num2">{{$t('unit2')}}</span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="v-report-table" v-loading="loading['IM']">
          <div class="v-report-table__block" v-show="controlList.IM == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('IMListText')}}
                    <span>{{$t('dataListSubTitle4')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.IM['1']" :placeholder="$t('reportPlaceholder4')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('IM', 1)">{{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('IM')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('IM')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="IM1"
                :type="'IM'"
                :data="table.IM"
                :total="total.IM"
                :page="currentPage.IM"
                :pageSize="pagination.pageSize"
                :fields="fields.IM"
                :hideFileds="['sendinviteNum']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'IM', 1)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div> -->

      <!-- 弹框 -->
      <winDialog class='v-report-diag'
        :closeAfter="closeAfter"
        :dialogShow.sync="dialog" 
        :title='dialogTitle' width="80%" >
        <template v-slot:bodyContent>
          <!-- 展品 模块1--->
          <div class='v-report-table__block' v-if="dialogType == 'product' && dialogNum == 1" v-loading="dialogLoading">
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- 展品 模块2--->
          <div class='v-report-table__block' v-if="dialogType == 'product' && dialogNum == 2"  v-loading="dialogLoading">
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :hideFileds="['times']"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- 展品 模块3--->
          <div class='v-report-table__block' v-if="dialogType == 'product' && dialogNum == 3"  v-loading="dialogLoading">
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :hideFileds="['times']"
                :pageSize="pagination.pageSize"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- 商贸圈 模块2--->
          <div class='v-report-table__block' v-if="dialogType == 'opportunity' && dialogNum == 2"  v-loading="dialogLoading">
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :hideFileds="['times']"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- 商贸圈 模块3--->
          <div class='v-report-table__block' v-if="dialogType == 'opportunity' && dialogNum == 3"  v-loading="dialogLoading">
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :hideFileds="['times']"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- 邀约 模块1--->
          <div class='v-report-table__block' v-if="dialogType == 'invite' && dialogNum == 1"  v-loading="dialogLoading">
              <!-- <div class="auditStatus bl-container" style="width: 100%; max-width: 100%">
                <el-radio-group v-model="scope" @change="stateChange">
                  <el-radio label="0" border>{{$t('common.all')}}</el-radio>
                  <el-radio label="1" border>{{$t('common.toBeConfirmed')}}</el-radio>
                  <el-radio label="2" border>{{$t('common.toBeConfirmedPerson')}}</el-radio>
                </el-radio-group>
              </div> -->
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :hideFileds="['times']"
                :pageSize="pagination.pageSize"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- 邀约 模块2--->
          <div class='v-report-table__block' v-if="dialogType == 'invite' && dialogNum == 2"  v-loading="dialogLoading">
              <!-- <div class="auditStatus bl-container" style="width: 100%; max-width: 100%">
                <el-radio-group v-model="scope" @change="stateChange">
                  <el-radio label="0" border>{{$t('common.all')}}</el-radio>
                  <el-radio label="1" border>{{$t('common.toBeConfirmed')}}</el-radio>
                  <el-radio label="2" border>{{$t('common.toBeConfirmedPerson')}}</el-radio>
                </el-radio-group>
              </div> -->
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :hideFileds="['times']"
                :pageSize="pagination.pageSize"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- IM 模块1--->
          <div class='v-report-table__block' v-if="dialogType == 'IM' && dialogNum == 1">
              <div class="report-todo v-clearfix">
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" :disabled='dialogTotal == 0' @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :hideFileds="['times']"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
        </template>
      </winDialog>

      <ChatWithExhibitor @invite="submitInvite" :action="action" />
  </div>
</template>

<script>

import fileDownload from 'js-file-download'
import { 
  exhibitorStatistic,
  exhibitorStatisticList,
  exhibitorStatisticListExport,
  productStatistic,
  productStatisticList,
  productStatisticListExport,
  productStatisticInfo,
  productStatisticInfoExport,
  commercialStatistic,
  commercialStatisticList,
  commercialStatisticListExport,
  commercialStatisticInfo,
  commercialStatisticInfoExport,
  inviteStatistic,
  inviteStatisticList,
  inviteStatisticListExport,
  inviteStatisticInfo,
  inviteStatisticInfoExport,
  getConnectAccount } from '@/api/statistics'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import { mapGetters } from 'vuex'
import VisitorData from '@/components/table/visitorList.vue'
import winDialog from '@/components/dialog/dialog'
import i18n from '@/utils/i18n'

export default {
  name: 'report',
  components: {
    VisitorData,
    winDialog
  },
  mixins: [inviteMixin],
  data() {
    return {
      pageLoading: false,
      dialog: false,
      dialogTitle: i18n.t('visitorList'),
      dialogData: [],
      dialogType: '',
      dialogNum: 0,
      dialogPage: 1,
      dialogTotal: 0,
      dialogFiledSort: [],
      dialogId: '',
      dialogLoading: false,
      scope: '0',
      // 模块数据
      modularDateNum: {
        actorBase: {
          '1': 0,
          '2': 0,
          '3': 0
        },
        product: {
          '1': 0,
          '2': 0,
          '3': 0
        },
        opportunity: {
          '1': 0,
          '2': 0,
          '3': 0
        },
        invite: {
          '1': 0,
          '2': 0
        },
        IM: {
          '1': 0
        }
      },
      // 搜索控件的绑定值
      searchForm: {
        product: {
          '1': '',
          '3': ''
        },
        opportunity: {
          '2': '',
          '3': ''
        },
        invite: {
          '1': '',
          '2': ''
        },
        IM: {
          '1': ''
        }
      },
      // 时间区间控件的绑定值
      listForm: {
        actorBase: '',
        product: '',
        opportunity: '',
        invite: '',
        IM: ''
      },
      // 每个模块的激活状态
      controlList: {
        actorBase: 0,
        product: 0,
        opportunity: 0,
        invite: 0,
        IM: 0
      },
      // table 的数据列表
      table: {
        actorBase: [],
        product: [],
        opportunity: [],
        invite: [],
        IM: []
      },
      // 总条数
      total: {
        actorBase: 0,
        product: 0,
        opportunity: 0,
        invite: 0,
        IM: 0
      },
      // 一页显示多少条数据
      pagination: {
        pageSize: 5,
      },
      // 模块的当前页码
      currentPage: {
        actorBase: 1,
        product: 1,
        opportunity: 1,
        invite: 1,
        IM: 1
      },
      // loading 状态
      loading: {
        actorBase: false,
        product: false,
        opportunity: false,
        invite: false,
        IM: false
      },
      // table 字段
      fields: {
        product1: [
          {
            prop: 'productName',
            label: i18n.t('productName'),
            align: 'center'
          },
          {
            prop: 'beViewPv',
            label: i18n.t('numOfVisits2'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'beViewUv',
            label: i18n.t('lookNum'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'beCollectionUv',
            label: i18n.t('numOfCollected'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            width: 150,
            align: 'center'
          }
        ],
        opportunity1: [
          {
            prop: 'content',
            label: i18n.t('oppContent'),
            align: 'center'
          },
          {
            prop: 'opportunityImg',
            label: i18n.t('oppImgVideo'),
            align: 'center'
          },
          {
            prop: 'commentCount',
            label: i18n.t('numOfcommented'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'likeCount',
            label: i18n.t('numOfLived'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            width: 150,
            align: 'center'
          }
        ],
        invite: [
          {
            prop: 'name',
            label: i18n.t('actorPerson'),
            align: 'center'
          },
          {
            prop: 'mobile',
            label: i18n.t('mobile'),
            align: 'center'
          },
          {
            prop: 'email',
            label: i18n.t('email'),
            align: 'center'
          },
          {
            prop: 'times',
            label: i18n.t('receivedInviteNum'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'sendTimes',
            label: i18n.t('sendInviteNum'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            width: 150,
            align: 'center'
          }
        ],
        IM: [
          {
            prop: 'actorVisitor',
            label: i18n.t("actorPerson"),
            align: 'center'
          },
          {
            prop: 'mobile',
            label: i18n.t('mobile'),
            align: 'center'
          },
          {
            prop: 'email',
            label: i18n.t('email'),
            align: 'center'
          },
          {
            prop: 'interactedNum',
            label: i18n.t('interactNum'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            width: 150,
            align: 'center'
          }
        ],
      },
      // 字段排序
      fieldSort: {
        actorBase: [],
        product: [],
        opportunity: [],
        invite: [],
        IM: []
      },
      endDatePicker() {
        return {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  mounted() {
    this.pageInit()
  },
  methods: {
    // 页面初始化
    pageInit() {
      this.pageLoading = true
      let timmer = null
      this.acount = 0
      this.modularData('actorBase')
      this.modularData('product')
      this.modularData('opportunity')
      this.modularData('invite')

      timmer = setInterval(() => {
        if (this.acount == 4) {
          clearInterval(timmer)
          timmer = null
          this.pageLoading = false
        }
      }, 1000)
    },
    // 获取接口请求参数
    getParams(type, level) {
      let startTime = ''
      let endTime = ''
      if (this.listForm[type]) {
        startTime = this.listForm[type][0]
        endTime = this.listForm[type][1]
      }
      if (level == 'data') {
        return {
          startTime,
          endTime
        }
      }
      let sortKey = ''
      let sortMode = ''
      let typeStr = ''
      let keyword = ''
      if (this.fieldSort[type].length) {
        sortKey = this.fieldSort[type][0]
        sortMode = this.fieldSort[type][1] == 'ascending' ? 'asc' : 'desc'
      }
      // 展商基本数据
      if (type === 'actorBase' || type === 'product') {
        if (this.controlList[type] == 1 || this.controlList[type] == 2) {
          typeStr = 'VIEW'
        } else {
          typeStr = 'COLLECTION'
        }
      }
      if (type === 'opportunity') {
        if (this.controlList[type] == 2) {
          typeStr = 'COMMENT'
        } else if (this.controlList[type] == 3) {
          typeStr = 'LIKE'
        }
      }
      if (type == 'invite') {
        if (this.controlList[type] == 1) {
          typeStr = 'INVITEE'
        } else {
          typeStr = 'INVITE'
        }
      }
      if (this.searchForm[type] && this.searchForm[type][this.controlList[type]]) {
        keyword = this.searchForm[type][this.controlList[type]]
      }
      if (level == 'list') {
        return {
          pageSize: this.pagination.pageSize,
          pageNum: this.currentPage[type],
          startTime,
          endTime,
          sortKey,
          sortMode,
          keyword,
          type: typeStr
        }
      }
      sortKey = ''
      sortMode = ''
      if (this.dialogFiledSort.length) {
        sortKey  = this.dialogFiledSort[0]
        sortMode = this.dialogFiledSort[1] == 'ascending' ? 'asc' : 'desc'
      }

      if (type == 'opportunity') {
        if (this.controlList[type] == 2) {
          typeStr = 'COMMENT'
        } else if (this.controlList[type] == 3) {
          typeStr = 'LIKE'
        }
      }

      if (type == 'invite') {
        if (this.controlList[type] == 1) {
          typeStr = 'INVITE'
        } else {
          typeStr = 'INVITEE'
        }
      }

      if (level == 'dialog') {
        return {
          pageSize: this.pagination.pageSize,
          pageNum: this.dialogPage,
          startTime,
          endTime,
          sortKey,
          sortMode,
          type: typeStr
        }
      }
    },
    // 获取每个模块的数据
    modularData(type) {
      let { startTime , endTime } = this.getParams(type, 'data')
      switch(type) {
        case 'actorBase':
          exhibitorStatistic({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type] = {
                '1': res.data.beViewPv,
                '2': res.data.beViewUv,
                '3': res.data.beCollectionUv
              }
            }
          }).finally(() => {
            this.acount ++
          })
          break
        case 'product':
          productStatistic({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type] = {
                '1': res.data.beViewPv,
                '2': res.data.beViewUv,
                '3': res.data.beCollectionUv
              }
            }
          }).finally(() => {
            this.acount ++
          })
          break
        case 'opportunity':
          commercialStatistic({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type] = {
                '1': res.data.commercial,
                '2': res.data.commentBeVisitor,
                '3': res.data.likeBeVisitor
              }
            }
          }).finally(() => {
            this.acount ++
          })
          break
        case 'invite':
          inviteStatistic({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type] = {
                '2': res.data.count,
                '1': res.data.countBeInvite
              }
            }
          }).finally(() => {
            this.acount ++
          })
          break
        case 'IM':
          break
      }
      if (this.searchForm[type]) {
        Object.keys(this.searchForm[type]).forEach(key => {
          this.searchForm[type][key] = ''
        })
      }
      if (this.controlList[type] != 0) {
        this.baseDataList(type)
      }
    },
    // 列表数据
    baseDataList(type, action) {
      if (this.modularDateNum[type][this.controlList[type]] == 0 && (this.controlList[type] == 0 || action === 1)) return
      if (this['controlList'][type] == 0) return
      let request = null
      let data = []
      let params = this.getParams(type, 'list')
      switch(type) {
        case 'actorBase':
          request = exhibitorStatisticList(params)
          break
        case 'product':
          request = productStatisticList(params)
          break
        case 'opportunity':
          request = commercialStatisticList(params)
          break
        case 'invite':
          request = inviteStatisticList(params)
          break
        case 'IM':
          break
      }
      this.loading[type] = true
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          data = res.data.list || []
          this.$set(this.total, type, res.data.total)
          this.$set(this.table, type, data)
        }
      }).finally(() => {
        this.loading[type] = false
      })
    },
    // 模块数据点击
    controlTodo(type, value, refName) {
      if (type === 'invite' && value === 2) {
        this.$router.push('/invite')
        return
      }

      if (this.loading[type]) return

      if (this.searchForm[type]) {
        this.searchForm[type][this.controlList[type]] = ''
      }

      if (this.controlList[type] == value) {
        this.controlList[type] = 0
      } else {
        this.$refs[refName] && this.$refs[refName].clearSort()
        this.controlList[type] = value
        this.fieldSort[type] = []
        this.$set(this.currentPage, type, 1)
        this.baseDataList(type, 1)
      } 
    },
    // 时间控件change
    dataPickerChange(type) {
      this.modularData(type)
    },
    // 搜索table
    searchTable(type) {
      this.pageChange(1, type)
    },
    // 导出操作
    exportData(type) {
      let request = null
      let params = this.getParams(type, 'list')
      params = {
        isStream: true,
        ...params
      }
      switch(type) {
        case 'actorBase':
          request = exhibitorStatisticListExport(params)
          break
        case 'product':
          request = productStatisticListExport(params)
          break
        case 'opportunity':
          request = commercialStatisticListExport(params)
          break
        case 'invite':
          request = inviteStatisticListExport(params)
          break
        case 'IM':
          break
      }
      this.loading[type] = true
      request.then(res => {
        fileDownload( res.data, `${type}_${new Date().getTime()}.xls`)
      }).then(() => {}).finally(() => {
        this.loading[type] = false
      })
    },
    // 收起
    packUp(type) {
      this.$set(this.controlList, type, 0)
    },
    // 客商明细 
    linkVisitorList(data, type, num) {
      let request = null
      let data2 = null
      let params = this.getParams(type, 'dialog')
      this.dialogId = data.id
      params = {
        itemId: this.dialogId,
        ...params
      }
      switch(type) {
        case 'product':
          request = productStatisticInfo(params)
          break
        case 'opportunity':
          request = commercialStatisticInfo(params)
          break
        case 'invite':
          request = inviteStatisticInfo(params)
          break
        case 'IM':
          break
      }
      !this.dialog && (this.loading[type] = true)
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          this.dialogType = type
          num && (this.dialogNum = num)
          this.dialog = true
          data2 = res.data.list || []
          this.dialogData = data2
          this.dialogTotal = res.data.total
          this.dialogLoading = true
        }
      }).finally(() => {
        this.dialog && (this.loading[type] = false)
        this.dialogLoading = false
      })      
    },
    // 数据排序
    sortChange(column, prop, order, type) {
      if (order === null) {
        this.fieldSort[type] = []
      } else {
        this.fieldSort[type] = [prop, order]
      }
      this.pageChange(1, type)
    },
    // 分页
    pageChange(page, type) {
      this.$set(this.currentPage, type, page)
      this.baseDataList(type)
    },
    // 弹框表格排序
    sortChangeDialog(column, prop, order) {
      if (order === null) {
        this.dialogFiledSort = []
      } else {
        this.dialogFiledSort = [prop, order]
      }
      this.pageChangeDialog(1)
    },
    // 弹框表格分页
    pageChangeDialog(page) {
      this.dialogPage =  page
      this.linkVisitorList({
        id: this.dialogId,
      }, this.dialogType)
    },
    // 切换弹框表格数据的状态（邀约弹框）
    stateChange() {
      // console.log(this.dialogType, this.dialogNum, this.dialogPage, this.dialogTotal, this.dialogFiledSort, this.scope)
    },
    // 弹框导出
    exportDataDialog() {
      let request = null
      let params = this.getParams(this.dialogType, 'dialog')
      params = {
        isStream: true,
        itemId: this.dialogId,
        ...params
      }
      switch(this.dialogType) {
        case 'product':
          request = productStatisticInfoExport(params)
          break
        case 'opportunity':
          request = commercialStatisticInfoExport(params)
          break
        case 'invite':
          request = inviteStatisticInfoExport(params)
          break
        case 'IM':
          break
      }
      this.dialogLoading = true
      request.then(res => {
        fileDownload( res.data, `${this.dialogType}_dialog_${new Date().getTime()}.xls`)
      }).then(() => {}).finally(() => {
        this.dialogLoading = false
      })
    },
    closeAfter() {
      this.dialogType = ''
      this.dialogNum = 0
      this.dialogPage = 1
      this.dialogTotal = 0
      this.dialogFiledSort = []
      this.scope = '0'
      this.dialogId = ''
    },
    // 联系客商
    linkVisitor(data) {
      getConnectAccount({
        itemId: data.id
      }).then(res => {
        return res.data
      }).then(res => {
        let data2 = res.data
        this.msgEventPerson({
          id: data.id,
          psjName: data.name,
          psjRank: data.post,
          psjComName: data.corporateName || data.corporateEnName,
          easemobAccount: data2.easemobAccount
        })
      })
    }
  }
}
</script>

